import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { AlertService } from 'src/app/services/alert.service';
import { Case } from 'src/app/models/case/case';
import { BaseComponent } from 'src/app/shared/components/base/base.component';
import { CaseService } from 'src/app/services/case.service';
import { DataService } from 'src/app/services/data.service';
import { SelectItem } from 'src/app/core/models/responses/select-item';
import { BankAccountCurrencyCodes, BankAccountLinkMode } from 'src/app/ui/components/bank-accounts/bank-account-create-edit-modal/bank-account-create-edit-modal.component';
import { BankAccountService } from 'src/app/services/bank-account.service';
import { CaseType } from 'src/app/models/enums/case-type';

@Component({
  selector: 'app-case-create-modal',
  templateUrl: './case-create-modal.component.html',
  styleUrls: ['./case-create-modal.component.scss']
})

export class CaseCreateModalComponent extends BaseComponent implements OnInit {
  @Input() presetExistingBankAccountId: number;
  @Input() presetBankName: string;
  @Input() presetCurrencyCode: string;
  form!: FormGroup;
  isDisabled: boolean = false;
  currentBranch = JSON.parse(localStorage.getItem('currentBranch'));
  banks: SelectItem[] = [];
  existingBankAccounts: SelectItem[] = [];
  currencyCodes = BankAccountCurrencyCodes;
  bankAccountMode: BankAccountLinkMode = 'new';
  modalRef: NgbModalRef;
  readonly CaseType = CaseType;
  constructor(
    private modalService: NgbModal,
    private service: CaseService,
    private alertService: AlertService,
    private dataService: DataService,
    private bankAccountService: BankAccountService

  ) {
    super();
  }

    model: Case = this.getEmptyModel();

  ngOnInit(): void {
    this.form = new FormGroup({
      caseName: new FormControl('', [Validators.required]),
    });
    this.dataService.getBank().toPromise().then(res => this.banks = res.data);
    this.dataService.getBankAccount().toPromise().then(res => this.existingBankAccounts = res.data);
  }

  bankAccountModeChanged() {
    this.model.existingBankAccountId = undefined;
    this.model.bankId = undefined;
  }

  get f(){
    return this.form.controls;
  }

  getEmptyModel(): Case {
    return {
      branchId: this.currentBranch.id,
      name: '',
      isDefault: false,
      caseType: CaseType.Cash,
      isBankAccount: false
    }
  }

  // isBankAccount arka uçta banka hesabı bağlama akışını tetikleyen ayrı bir bayrak;
  // tip seçimiyle birlikte tutulur ki eski uç davranışı bozulmasın.
  caseTypeChanged() {
    this.model.isBankAccount = this.model.caseType === CaseType.Bank;
    if (this.model.caseType !== CaseType.Bank) {
      this.model.existingBankAccountId = undefined;
      this.model.bankId = undefined;
      this.model.bankAccountCurrencyCode = undefined;
    }
  }

  open(content) {
    if (this.presetExistingBankAccountId) {
      this.createForExistingBankAccount();
      return;
    }
    this.modalRef = this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'});
    this.modalRef.result.then((result) => {}, (reason) => {});
  }

  createForExistingBankAccount() {
    const name = `${this.presetBankName} - ${this.presetCurrencyCode}`;
    this.alertService
      .showConfirmAlert(
        `"${name}" adıyla yeni bir kasa oluşturulacak ve seçili banka hesabı bu kasaya bağlanacak. Devam etmek istiyor musunuz?`,
        'Evet, Oluştur',
        'Vazgeç'
      )
      .then((result) => {
        if (!result.isConfirmed) {
          return;
        }
        this.isDisabled = true;
        const model: Case = {
          branchId: this.currentBranch.id,
          name,
          isDefault: false,
          caseType: CaseType.Bank,
          isBankAccount: true,
          existingBankAccountId: this.presetExistingBankAccountId,
        };
        this.service.create(model).toPromise().then(res => {
          this.isDisabled = false;
          if (res.isSuccess) {
            this.service.refreshIndex.next('');
            this.bankAccountService.refreshIndex.next();
            this.alertService.showSuccess('Yeni kasa eklendi.');
          } else {
            this.alertService.showError();
          }
        }).catch(() => this.isDisabled = false);
      });
  }

  isValid(): boolean {
    if (this.model.caseType !== CaseType.Bank) {
      return true;
    }
    let messages: string[] = [];
    if (this.bankAccountMode === 'existing') {
      if (!this.model.existingBankAccountId)
        messages.push('Banka hesabı seçiniz.');
    } else {
      if (!this.model.bankId)
        messages.push('Banka seçiniz.');
      if (!this.model.bankAccountCurrencyCode)
        messages.push('Para birimi seçiniz.');
    }

    if (messages.length > 0) {
      this.alertService.showErrorsToast(messages);
      return false;
    } else return true;
  }

  submit(){
    this.model.name = this.f.caseName.value;
    if (!this.isValid()) {
      return;
    }
    this.isDisabled = true;
    const wasExistingBankAccount = this.bankAccountMode === 'existing' && !!this.model.existingBankAccountId;
    this.service.create(this.model).toPromise().then(res => {
      this.isDisabled = false;
      if(res.isSuccess){
        this.form.reset();
        const createdAsPos = this.model.caseType === CaseType.Pos;
        this.model = this.getEmptyModel();
        this.bankAccountMode = 'new';
        if (createdAsPos)
          this.alertService.showInfo('Kasa oluşturuldu. POS ayarlarını Kasa > POS Ayarları ekranından tanımlayınız.');
        this.modalRef.close('Save click');
        this.service.refreshIndex.next('');
        if (wasExistingBankAccount) {
          this.bankAccountService.refreshIndex.next();
        }
        this.alertService.showSuccess('Yeni kasa eklendi.');
      }
    }).catch(err => this.isDisabled = false);
  }

}
